/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_swap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swap units`)
};

const es_uc_swap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intercambiar unidades`)
};

const de_uc_swap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheiten tauschen`)
};

const nl_uc_swap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wissel eenheden`)
};

const fr_uc_swap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverser les unités`)
};

const it_uc_swap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scambia unità`)
};

const pt_br2_uc_swap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar unidades`)
};

const pt_uc_swap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar unidades`)
};

const ja_uc_swap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単位を入れ替える`)
};

const zh_uc_swap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交换单位`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_swap = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_swap(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_swap", locale)
	if (locale === "en") return en_uc_swap(inputs)
	if (locale === "es") return es_uc_swap(inputs)
	if (locale === "de") return de_uc_swap(inputs)
	if (locale === "nl") return nl_uc_swap(inputs)
	if (locale === "fr") return fr_uc_swap(inputs)
	if (locale === "it") return it_uc_swap(inputs)
	if (locale === "pt-BR") return pt_br2_uc_swap(inputs)
	if (locale === "pt") return pt_uc_swap(inputs)
	if (locale === "ja") return ja_uc_swap(inputs)
	return zh_uc_swap(inputs)
};